/**
 * Created by LinFF on 2017/5/6.
 */
(function($){
    'use strict';

    var ModuleName = 'cy_lsgp';

    var Module = function(elem,options){
        this.elem = $(elem);
        this.options = options;
        this.stop = true;
        this.currD = null;/*存储当前月历第一组的日期*/
        this.newDate = null;/*存储点击prev按钮之后变动的日期*/
        this.dataArr = [];/*存储数据*/
        this.dataArrSortbyDate = {};/*資料依照日期分類*/
        this.dataToRender = [];/*要渲染的數據*/
        this.selectTD = null;/*当前月的所有TD*/
        this.$nextButton = null;
        this.$prevButton = null;
        this.guaranteed = this.options.dataKeySetting['保证出团'];//保证出团
        this.status = this.options.dataKeySetting['状态'];//状态
        this.availableVacancy = this.options.dataKeySetting['可卖团位'];//可賣團位
        this.totalVacnacy = this.options.dataKeySetting['总团位'];//總團位
        this.price = this.options.dataKeySetting['价格'];//價格
        this.group = '看更多团';//区分看更多团的html结构
    };

    Module.DEFAULTS = {
        monthNumber: 'double', // single, double
        showMonthControl: true,
        minMonthDate: '',
        maxMonthDate: '',
        initYearMonth: '',
        initData: [],
        selectedDate: null,
        dataKeySetting: {
            '保证出团': 'guaranteed',
            '状态': 'status',
            '可卖团位': 'availableVacancy',
            '总团位': 'totalVacnacy',
            '价格': 'price'
        },
        onClickPrev: function( $prevBtn,data){},
        onClickNext: function( $nextBtn,data ){},
        onClickDate: function( $thisDate ){}
    };
    //初始化
    Module.prototype.init = function(){
        this.inputData(this.options.initData);
        this.renderData(this.options.initYearMonth);
    };

    Module.prototype.showMonthController = function() {
        var $header = this.elem.find('.header');
        // console.log($header, this.options.showMonthControl);
        if ( this.options.showMonthControl === false ) {
            $header.hide();
        } else {
            $header.show();
        }
    };

    /*渲染数据*/
    Module.prototype.renderData = function(arg){
        if( typeof arg == 'string' ){
            this.currD = arg;
        } else if ( arg instanceof Array ){
            this.currD = arg[0];
        }
        var data = this.currD.substring(0,4) + '-'+ this.currD.substring(4);
        var nextD = new Date(data);
        var curr = new Date(data);
        this.currD = curr;
        var next = new Date(nextD.setMonth(nextD.getMonth()+1));
        var calendar = this.elem;
        var prevDate = curr.getFullYear() + ' ' + (curr.getMonth()+1) + '月';
        var nextDate = next.getFullYear() + ' ' + (next.getMonth()+1) + '月';
        if(this.stop){
            /*将框架append到页面中*/
            calendar.html(this.frameTemp(prevDate,nextDate));
            //var prevTable = this.options.monthNumber === 'double' ? calendar.find('.js_prev_month_table') : calendar.find('.month_table');
            /*20180321 添加只显示价格日历*/
            var prevTable = null;

            switch(this.options.monthNumber){
                case "double":
                    prevTable = calendar.find('.js_prev_month_table');
                    break;
                case "single":
                case "simple":
                    prevTable = calendar.find('.month_table');
                    break;
            }
            /*end*/
            var prevTbody = prevTable.find('tbody');
            var nextTable = calendar.find('.js_next_month_table');
            var nextTbody = nextTable.find('tbody');
            this.$nextButton = this.elem.find('.js_next');
            this.$prevButton = this.elem.find('.js_prev');
            // console.log('prevTable:', prevTable, 'nextTable:', nextTable);
            // console.log('prevTbody:', prevTbody, 'nextTbody:', nextTbody);
            this.createCalendar(curr,prevTbody);
            this.createCalendar(next,nextTbody);
            this.onClickPrevEvent();
            this.onClickNextEvent();
            this.showMonthController();
            this.onClickTd();

            /*将数据填到表格中*/
            for(var i = 0; i < this.dataToRender.length; i++){
                var elem = calendar.find('td[date='+'\'' + this.dataToRender[i].date+'\''+']');
                var selectTd = elem.find('.js_day');
                var haveGroups = false;
                var tip = null;
                /*20180323 只显示价格日历*/
                var className = this.options.monthNumber == 'simple' ? 'hasData hasPrice' : 'hasData';
                elem.addClass(className);
                /*end*/
                elem.data(this.dataToRender[i]);
                if(!this.haveSeveralGroups(this.dataToRender[i].date) && this.options.monthNumber != 'simple'){
                    tip = elem.find('.js_tip');
                    // console.log(selectTd);
                    selectTd.append(this.dataTemp(1, this.dataToRender[i]));
                    if(this.dataToRender[i][this.guaranteed]){
                        tip.show();
                    } else{
                        tip.hide();
                    }
                }
                /*20180321 只显示价格日历*/
                else if(this.options.monthNumber == 'simple'){
                    tip = elem.find('.js_tip');
                    // console.log(selectTd);
                    selectTd.append(this.dataTemp(2, this.dataToRender[i]));
                }
                /*end*/
                else{
                    selectTd.append(this.dataTemp(0, this.dataToRender[i]));
                }
            }
        }
    };

    /*存储数据*/
    Module.prototype.inputData = function(arg){
        var argLen = arg.length;
        var dataArrLen = this.dataArr.length;

        if(dataArrLen == 0){ //首次存入数据
            this.dataArr = arg;
        } else {
            for(var i = 0;i < argLen;i++) {
                var index = -1;
                for(var j = 0;j < this.dataArr.length; j++){
                    if(this.dataArr[j].date == arg[i].date && this.dataArr[j].id == arg[i].id){
                        index = j;
                        break;
                    }
                }
                if(index != -1){
                    this.dataArr[index] = arg[i];
                }else{
                    this.dataArr.push(arg[i]);
                }
            }
        }
        //Sort data by date
        this.dataArrSortbyDate={};
        for(var i = 0; i < this.dataArr.length; i ++) {
            var date  = this.dataArr[i].date;
            if(date in this.dataArrSortbyDate) {
                this.dataArrSortbyDate[date].push(this.dataArr[i]);
            } else {
                this.dataArrSortbyDate[date] = [this.dataArr[i]];
            }
        }

        // 取出每日最低價
        var keys = Object.keys(this.dataArrSortbyDate);
        this.dataToRender = [];
        for(var i = 0; i < keys.length; i ++) {
            var targetIndex = 0,
                lowestPrice;
            for(var j = 0; j < this.dataArrSortbyDate[keys[i]].length; j++) {
                var currPrice = this.dataArrSortbyDate[keys[i]][j].price.toString().match(/\d+/g);
                if (!lowestPrice) {
                    if (currPrice) {
                        lowestPrice = parseInt(currPrice.join(''));
                    }
                } else {
                    if (currPrice && currPrice < lowestPrice) {
                        lowestPrice = parseInt(currPrice.join(''));
                        targetIndex = j;
                    }
                }
            }
            this.dataToRender.push(this.dataArrSortbyDate[keys[i]][targetIndex]);
        }
    };
    Module.prototype.haveSeveralGroups = function (date) {
        if (this.dataArrSortbyDate[date].length > 1) return true;
    }
    /*td点击事件*/
    Module.prototype.onClickTd = function(){
        var _this = this;
        this.selectTD = this.elem.find('.currentDays');
        this.selectTD.bind('click',function(){
            if ($(this).hasClass('hasData')) {
                _this.options.onClickDate.call(_this,$(this));
                _this.options.selectedDate = $(this).attr('date');
                _this.selectTD.removeClass('active');
                $(this).addClass('active');
            }
        });
    };

    /*prev点击事件*/
    Module.prototype.onClickPrevEvent = function(){
        var _this = this;
        this.$prevButton.on('click',function(e){
            e.preventDefault();
            _this.goMonth('prev');
        });
    };

    /*next点击事件*/
    Module.prototype.onClickNextEvent = function(){
        var _this = this;
        this.$nextButton.on('click',function(e){
            e.preventDefault();
            _this.goMonth('next');
        });
    };

    /*上两个月*/
    Module.prototype.prevMonth = function(){
        this.stop = true;
        this.renderData(this.newDate);
    };

    /*下两个月*/
    Module.prototype.nextMonth = function(){
        this.stop = true;
        this.renderData(this.newDate);
    };

    Module.prototype.goMonth = function( prevnext ){
        var _this = this;
        var yearNumberBefore = this.currD.getFullYear();
        var monthNumberBefore = this.currD.getMonth()+1;
        var monthNumberAfter;
        var monthStringAfter;
        var monthLenAfter;
        var monthAfter;
        var isNext = function( a, b, c ) {
            var isTure = true;
            if ( typeof a === 'number' ) {
                if ( a > b ) {
                    isTure = true;
                } else if ( a < b ) {
                    isTure = false;
                } else {
                    console.log('You assign month number same with current');
                }
            } else if ( typeof a === 'string' ) {
                if ( a === 'prev' ) {
                    isTure = false;
                } else if ( a === 'next' ) {
                    isTure = true;
                } else if ( /([12][0-9]{3})(0[1-9]|1[0-2])/.test(a) ) {
                    if ( c > Number(a.substr(0,4)) ) {
                        isTure = true;
                    } else if ( b > Number(a.slice(-2)) ) {
                        isTure = true;
                    } else {
                        isTure = false;
                    }
                } else {
                    throw 'You must assign `prev` or `next` or number';
                }
            } else {
                throw 'You must assign `prev` or `next` or number';
            }
            return isTure;
        }( prevnext, monthNumberBefore, yearNumberBefore );
        var monthDistanceNum = function( a, b, c, d, e ) {
            var num;
            var yearNumberAfter;
            var monthNumberAfter;
            var yearDistance;
            var monthDistance;
            if ( typeof a === 'number' ) {
                num = a - b;
            } else if ( a === 'prev' || a === 'next'  ) {
                if ( e === 'double' ) {
                    num = d ? 2 : -2;
                }
                /*20180322 只显示价格日历*/
                else if ( e === 'single' || e === 'simple') {
                    num = d ? 1 : -1;
                }
                /*end*/
            } else if ( /([12][0-9]{3})(0[1-9]|1[0-2])/.test(a) ) {
                yearNumberAfter = Number(a.substr(0,4));
                monthNumberAfter = Number(a.slice(-2));
                yearDistance = (yearNumberAfter - c) * 12;
                monthDistance = monthNumberAfter - b;
                num = yearDistance + monthDistance;
            } else {
                throw 'You must assign `prev` or `next` or number';
            }
            return num;
        }( prevnext, monthNumberBefore, yearNumberBefore, isNext, this.options.monthNumber )
        var callback = isNext ? this.options.onClickNext : this.options.onClickPrev;
        var $contorlButton = !!isNext ? this.$nextButton : this.$prevButton;
        this.setMonthDate( monthDistanceNum );
        monthNumberAfter = this.currD.getMonth()+1;
        monthStringAfter = monthNumberAfter.toString();
        monthLenAfter = monthStringAfter.length;
        monthAfter = monthLenAfter >= 2 ? monthStringAfter : '0' + monthStringAfter;
        this.newDate = this.currD.getFullYear().toString() + monthAfter;

        // Check if nextStatus is avaliable( Larger than maxMonthDate or smaller than minMonthDate).
        var opts = this.options;
        var minD = this.transDateFormat(opts.minMonthDate, 'string');
        var maxD = this.transDateFormat(opts.maxMonthDate, 'string');
        if ( !!minD && (this.newDate < minD)) {
            console.log("Month can't be SMALLER than MAX.")
            this.setMonthDate(-monthDistanceNum);
        } else if ( !!maxD && (maxD < this.newDate)) {
            console.log("Month can't be LARGER than MAX.")
            this.setMonthDate(-monthDistanceNum);
        } else {
            this.renderData(this.newDate);
        }
        if ( typeof callback === 'function' ) {
            callback.call(_this, _this.elem, $contorlButton, this.newDate);
        }
    };

    Module.prototype.transDateFormat = function(date, type) {
        var transform = function(date) {
            if( typeof date == 'string' ){
                var year = date.substring(0,4);
                var month = date.substring(4) - 1;
                return new Date( year, month )
            } else if ( date instanceof Array ){
                var month = date.getMonth() + 1;
                return date.getFullYear() + (9 < month?month:'0'+month)
            } else console.log("type must be 'data' or 'date'")
        }

        if (type == 'string') {
            if (typeof date == 'string' )  return date;
            else return transform(date);
        } else if ( type == 'date' ) {
            if ( date instanceof Array )  return date;
            else return transform(date);
        }
    }

    /*重置当前两个月*/
    Module.prototype.setMonthDate = function(month, year){
        this.currD = new Date(this.currD.setMonth(this.currD.getMonth()+month));
    };

    /*构建日历*/
    Module.prototype.createCalendar = function(currDate,tbody){
        var currMonth = new Date(currDate.getFullYear(),currDate.getMonth()+1,0);
        var currMonthDays = currMonth.getDate();
        var lastMonth = new Date(currDate.getFullYear(),currDate.getMonth(),0);
        var lastMonthDays = lastMonth.getDate();
        var currMonthFirstDay = new Date(currDate.getFullYear(),currDate.getMonth(),1);
        var day = currMonthFirstDay.getDay();
        var allDays = currMonthDays-(7-day);
        var count = allDays % 7;
        var days = allDays - count;
        var lastTrDays = currMonthDays - count;
        var d = 7 - day;
        var trCount = Math.floor(days / 7);
        var str = '';
        var str2 = '';
        var maxNum = 14;
        var a = 7;
        var everyDay = '';
        var year = currDate.getFullYear();
        var math = (currDate.getMonth()+1).toString().length >=2 ? (currDate.getMonth()+1).toString() : '0' + (currDate.getMonth()+1).toString();

        /*第一行表格设置 */
        if(day > 0){
            /*计算上个月在第一行占多少格*/
            str += '<tr class="days">';
            for(var i1 = (0 - (day-1));i1 <= 0;i1++){
                str += this.daysTemp(0,(lastMonthDays + i1));
            }
            /*计算当前月在第一行占多少格*/
            for(var i2 = 0; i2 < (7-day);i2++){
                everyDay = year + '/' + math + '/' + '0' + (i2+1);
                str += this.daysTemp(1,(i2+1),everyDay);
            }
            str += '</tr>';
        }else{
            str += '<tr class="days">';
            for(var i3 = 0;i3 < 7;i3++){
                everyDay = year + '/' + math + '/' + '0' + (i3+1);
                str += this.daysTemp(1,(i3+1),everyDay);
            }
            str += '</tr>'
        }

        /*二到六行表格设置*/
        /*以下方法不区分trCount的值 默认的创建日历方式*/
        for(var i4 = 0;i4 < trCount;i4++){
            str += '<tr class="days">';
            for(var c = 0;c < 7;c++){
                if(d<currMonthDays-count){
                    var dayNum = '';
                    d++;
                    d.toString().length >= 2 ? dayNum = d : dayNum = '0'+ d;
                    everyDay =  year + '/' + math + '/' + (dayNum);
                    str += this.daysTemp(1,(d),everyDay);
                }
            }
            str += '</tr>';
        }
        /*
         * 当trCount == 4时 此时已经创建总共五行的tr 只要判断count 余数的情况 即可创建第六行
         * 当trCount == 3时 此时已经创建总共四行的tr 判断count 余数的情况 即可创建第五行
         * */
        if(count == 0){
            str += '<tr class="days">';
            for(var i5 = 1;i5 <= 7;i5++){
                str += this.daysTemp(0,(i5));
            }
            str += '</tr>';
        }else{
            str += '<tr class="days">';
            for(var i6 = 1;i6 < count + 1;i6++){
                everyDay =  year + '/' + math + '/' + (lastTrDays + i6);
                str += this.daysTemp(1,(lastTrDays + i6),everyDay,'none','截止','99','99','$9999');
            }
            for(var i7 = 1;i7 < 7 - count + 1;i7++){
                str += this.daysTemp(0,(i7));
            }
            str += '</tr>';
        }
        $(tbody).empty().append(str);

        /*
         * 当trCount == 3时 需要判断count 的两种情况 从而对第六行进行设置 填充正确的日期
         * */
        if(trCount == 3 && count > 0){
            str2 += '<tr class="days">';
            for(var i8 = 7 - count+1; i8 < 7+7-count+1;i8++){
                str2 += this.daysTemp(0,(i8));
            }
            str2 += '</tr>';
        }else if(trCount == 3 && count == 0){
            str2 += '<tr class="days">';
            for(var i9 = 0;i9 < 7;i9++){
                if(a < maxNum){
                    a++;
                    str2 += this.daysTemp(0,(a));
                }
            }
            str2 += '</tr>';
        }
        $(tbody).append(str2);
    };

    /* 构建日历header以及table框架*/
    Module.prototype.frameTemp = function(prevData,nextData){
        /*20180321 只显示价格日历*/
        //var isDouble = this.options.monthNumber !== 'single';
        var className = '';

        switch (this.options.monthNumber){
            case "double":
                className = '';
                break;
            case "single":
                className = 'single';
                break;
            case "simple":
                className = 'simple';
                break;
        }

        var week = className == 'simple'? '<th>日</th> <th>一</th> <th>二</th> <th>三</th> <th>四</th> <th>五</th> <th>六</th>' : '<th>星期日</th> <th>星期一</th> <th>星期二</th> <th>星期三</th> <th>星期四</th> <th>星期五</th> <th>星期六</th>';

        var isDoubleTemp = '<div class="calendar' + ' ' + className + '">'+
            '<div class="prev_month month">'+
            '<div class="header">'+
            '<a href="javascript:void(0)" class="prev js_prev"><i></i></a>'+
            '<span class="date">' + prevData + '</span>'+
            '</div>'+
            '<div class="main">'+
            '<table class="js_prev_month_table">'+
            '<thead> <tr class="week"> <th>星期日</th> <th>星期一</th> <th>星期二</th> <th>星期三</th> <th>星期四</th> <th>星期五</th> <th>星期六</th> </tr> </thead>'+
            '<tbody></tbody>'+
            '</table>'+
            '</div>'+
            '</div>'+
            '<div class="next_month month">'+
            '<div class="header">'+
            '<a href="javascript:void(0)" class="next js_next"><i></i></a>'+
            '<span class="date">' + nextData + '</span>'+
            '</div>'+
            '<div class="main">'+
            '<table class="js_next_month_table">'+
            '<thead> <tr class="week"> <th>星期日</th> <th>星期一</th> <th>星期二</th> <th>星期三</th> <th>星期四</th> <th>星期五</th> <th>星期六</th> </tr> </thead>'+
            '<tbody></tbody>'+
            '</table>'+
            '</div>'+
            '</div>'+
            '</div>';
        var isSingleTemp = '<div class="calendar' + ' ' + className + '">'+
            '<div class="month">'+
            '<div class="header">'+
            '<a href="javascript:void(0)" class="prev js_prev"><i></i></a>'+
            '<span class="date">' + prevData + '</span>'+
            '<a href="javascript:void(0)" class="next js_next"><i></i></a>'+
            '</div>'+
            '<div class="main">'+
            '<table class="month_table">'+
            '<thead> <tr class="week">'+ week +'</tr> </thead>'+
            '<tbody></tbody>'+
            '</table>'+
            '</div>'+
            '</div>'+
            '</div>';
        /*20180321 只显示价格日历*/
        switch (this.options.monthNumber){
            case "double":
                return isDoubleTemp;
                break;
            case "single":
            case "simple":
                return isSingleTemp;
                break;
        }
        /*end*/
    };

    /*構建數據html模板*/
    Module.prototype.dataTemp = function(type, data){
        var statusLabel = '<span class="status js_status">'+ data[this.status] +'</span>';
        switch(data[this.status]) {
            case "报名":
            case "预定":
                statusLabel = '<span class="status js_status lb-org">'+ data[this.status] +'</span>';
                break;
            case "额满":
            case "关团":
                statusLabel = '<span class="status js_status lb-gray">'+ data[this.status] +'</span>';
                break;
            case "请洽专员":
                statusLabel = '<a class="status js_status callagent" href="' + data.href + '" data-toggle="mdl_lnls" data-target="'+ data.lightboxTarget +'">'+
                                data[this.status] +'</a>';
                break;
        }
        /*20180321 只显示价格日历*/
        this.options.monthNumber != "simple" && this.haveSeveralGroups(data.date) && (statusLabel = '<span class="status js_status lb-blue">'+ '看更多团' +'</span>');
        /*end*/
        if(type == 1){
            return  '<div class="details js_details">'+
                statusLabel+
                '<span class="sell">可卖 : <i class="js_sell">'+ data[this.availableVacancy] + '</i></span>'+
                '<span class="group">团位 : <i class="js_group">'+ data[this.totalVacnacy] +'</i></span>'+
                '<span class="price js_price">'+ data[this.price] +'</span>'+
                '</div>';
        }
        /*20180321 修改日历days内容*/
        else if(type == 2){
            return '<div class="details js_details">'+
                '<span class="price js_price">'+ data[this.price] +'</span>'+
                '</div>';
        }
        /*end*/
        else{
            /*20180321 修改日历days内容*/
            var words = null;
            if(this.options.monthNumber != "simple" && data[this.price]){
                var result = data[this.price].toString();
                words = result.indexOf("起")+1 == data[this.price].length ? '' : '<span class="up">起</span>'
            }else{
                words = '';
            }
            /*end*/
            return  '<div class="details more_group js_details">'+
                statusLabel+
                '<span class="price js_price">'+ data[this.price] + words+'</span>'+
                '</div>';
        }
    };

    /*構建日曆天數html模板 */
    Module.prototype.daysTemp = function( type, date, days ){
        var _this = this;
        var opts = _this.options;
        if( type == 1 ) {
            return '<td class="currentDays'+ (days==opts.selectedDate?' active':'') +'" date="'+ days +'">'+
                        '<div class="day js_day">'+
                        '<span class="num">'+ date +'</span>'+
                        '<span class="tip js_tip">成团</span>'+
                        '</div>'+
                    '</td>'
        } else {
            return  '<td class="disabled">\
                        <div class="day otherMonth"></div>\
                     </td>\
                    '
        }
    };

    $.fn[ModuleName] = function ( options1,options2 ) {
        return this.each(function(){
            var $this = $(this);
            var module = $this.data( ModuleName );
            var opts = null;
            if ( !!module ) {
                if ( typeof options1 === 'string' &&  typeof options2 === 'undefined' ) {
                    module[options1]();
                } else if ( typeof options1 === 'string' && typeof options2 === 'string' || options2 instanceof Array || typeof options2 === 'number' ) {
                    module[options1](options2);
                } else {
                    console.log('unsupported options!');
                    throw 'unsupported options!';
                }
            } else {
                opts = $.extend( {}, Module.DEFAULTS,( typeof options1 === 'object' && options1 ));
                module = new Module(this, opts);
                $this.data( ModuleName, module );
                module.init();
            }
        });
    };
})(jQuery);


// WEBPACK FOOTER //
// ./magaele/cy_lsgp/module.js